<template>
  <div>
    <div class="mb-12 text-16px whitespace-nowrap w-full">
      <span class="tab" v-for="tab in tabs" :key="tab.key" :class="{
        active: curTab === tab.key,
        hover: curTab !== tab.key,
      }" @click="curTab = tab.key">
        {{ tab.name }}
      </span>
    </div>
    <el-form :model="form">
      <el-form-item v-if="curTab == 'phone'">
        <el-input v-model="form.phone" autocomplete="off" :placeholder="$t('请输入手机号')" autofocus type="tel"
          prefix-icon="iconfont icon-zhanghao">
          <el-select slot="prepend" :placeholder="$t('区号')" v-model="form.codes" class="w-7rem">
            <el-option v-for="item in codes" :key="item.id" :label="`${item.value}(${item.key})`"
              :value="item.key"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item v-else-if="curTab == 'email'">
        <el-input v-model="form.email" autocomplete="off" :placeholder="$t('请输入邮箱')" autofocus
          prefix-icon="iconfont icon-zhanghao">
        </el-input>
      </el-form-item>
      <el-form-item v-if="curTab == 'phone' && message == 'code'">
        <el-row class="border rounded" :class="{ code_active: isActive }">
          <el-col :span="14">
            <el-input class="code" :placeholder="$t('请输入验证码')" prefix-icon="iconfont icon-yanzhengma" v-model="form.code"
              @focus="isActive = true" @blur="isActive = false" />
          </el-col>
          <el-col :span="1">
            <div class>|</div>
          </el-col>
          <el-col :span="7">
            <div class="cursor-pointer whitespace-nowrap overflow-hidden" @click="sendCode" v-if="code_show">{{ $t("发送验证码") }}</div>
            <div v-else class="whitespace-nowrap">{{ $t("等待") }}{{ count }}s</div>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="message == 'password' || curTab == 'email'">
        <el-input v-model="form.password" autocomplete="off" :placeholder="$t('请输入密码')" show-password>
          <template #prefix>
            <span class="iconfont icon-mima"></span>
          </template>
        </el-input>
      </el-form-item>

      <el-button type="primary" @click="login()" class="w-full" :disabled="btnState">{{ $t("登录") }}</el-button>

      <p class="text-sm mt-4 text-right" v-if="curTab == 'phone'" @click="checkout">
        <el-link type="info" :underline="false">{{ message == 'password' ? $t("切换至验证码登录") : $t("切换至密码登录") }}</el-link>
      </p>
      <!-- <p class="text-sm mt-6">
        <el-link type="info" :underline="false">—— 快捷登录 ——</el-link>
      </p>-->
    </el-form>

  </div>
</template>

<script>
import { reactive, ref, onMounted, computed,toRefs } from "@vue/composition-api";
import { defineComponent } from "@vue/runtime-dom";
export default defineComponent({
  setup(props, ctx) {
    const message = ref('code');
    const curTab = ref('phone')
    const tabs = reactive([
      {
        key: 'phone',
        name: ctx.root.$t("手机登录"),
      },
      {
        key: 'email',
        name: ctx.root.$t("邮箱登录"),
      },
    ]);
    const form = reactive({
      //区号
      codes: "",
      email: "",
      phone: "",
      // email_phone: "", //472497084@qq.com
      password: "", //123456
      //验证码
      code: "",
    });
    const isActive = ref(false);

    const codes = ref();
    onMounted(async () => {
      const res = await ctx.root.$lazy("datadic");
      codes.value = res.countryareacode;
    });
    // const show = ref(true);
    // const regPhone =
    //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    // const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    const login = async() => {
      let {password,email,phone,code,codes} = form
      let query = ref()
      if (curTab.value == 'phone') {
        if (message.value == 'code') {
          query.value = {phone:codes+'-'+phone,code}
        } else {
          query.value = {phone:codes+'-'+phone,password};
        }
      } else {
        query.value= {email,password};
      }
      if (query.value.password) {
        ctx.root.$doing(ctx.root.$t("正在登录..."));
        let res = await ctx.root.$callapi("user/login", query.value);
        ctx.root.$done();
        if (res?.data) {
          window.location.reload();
        }
      } else {
        ctx.root.$doing(ctx.root.$t("正在登录..."));
        let res = await ctx.root.$callapi("user/phoneLogin", query.value);
        ctx.root.$done();
        if (res?.data) {
          window.location.reload();
        }
      }
      
    };
    const checkout = () => {
      message.value = message.value == "code" ? "password" : "code";
    };

    const code_show = ref(true);
    const count = ref();
    const whenSendcode = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      code_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count.value = countDown;
      const timer = setInterval(() => {
        if (count.value > 0 && count.value <= 60) {
          count.value--;
        } else {
          code_show.value = true;
          clearInterval(timer);
        }
      }, 1000);
    };
    const sendCode = async () => {
      if (curTab.value == 'phone') {
        if (!form.codes) {
          return ctx.root.$toast(ctx.root.$t("请选择区号"), "warning")
        }
        if (!form.phone) {
          return ctx.root.$toast(ctx.root.$t("请填写手机号"), "warning")
        }
        const re_phone = await ctx.root.$callapi("sendVerifyPhone", {
          phone: form.codes + '-' + form.phone,
          usetype: "login",
        });
        if (re_phone.code == 0) {
          whenSendcode();
        }
      }
    };
    const btnState = computed(() => {
      if (curTab.value == 'phone') {
        return ((form.code && form.phone && form.codes) || (form.codes && form.password && form.phone)) ? false : true
      } else {
        return (form.email && form.password) ? false : true
      }
    })
    //当监测到输入号码为邮箱时禁用区号

  
    return {
      form,
      login,
      checkout,
      code_show,
      count,
      message,
      btnState,
      isActive,
      codes,
      curTab,
      tabs,
      sendCode
    };
  },
});
</script>

<style scoped lang="scss">.code ::v-deep .el-input__inner {
  border: 0;
}
.code_active {
  border-color: #34b66b;
}
.tab {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  cursor: pointer;
  display: inline-block;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  width: 50%;
}
.hover:hover {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.active {
  --tw-border-opacity: 1;
  border-color: rgba(21, 186, 99, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}</style>
